import { useMemo } from 'react';
import { array } from 'fp-ts';
import { Reservation } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getReservationsByAvailabilityBlockId } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { isReservationCancellable } from '@mews-commander/legacy-entities/src/utils/reservations';
import { useCommanderSelector } from '@mews-commander/utils';

interface AvailabilityBlockReservations {
    allReservations: Reservation[];
    cancellableReservations: Reservation[];
    nonCancellableReservations: Reservation[];
}

export const useAvailabilityBlockReservations = (availabilityBlockId: string): AvailabilityBlockReservations => {
    const enterpriseId = useCurrentEnterpriseId();

    const reservations = useCommanderSelector((state) =>
        getReservationsByAvailabilityBlockId(state, { availabilityBlockId, enterpriseId })
    );

    return useMemo(() => {
        const allReservations = [...reservations];

        const { right, left } = array.partition(isReservationCancellable)(allReservations);

        return {
            allReservations,
            cancellableReservations: right,
            nonCancellableReservations: left,
        };
    }, [reservations]);
};
